import React from 'react'
import { ButtonBase } from '@material-ui/core'

import ActionContext from 'components/ActionContext'
import FeaturedMatch from 'components/FeaturedMatch'
import CenteredContent from 'components/CenteredContent'

import { MatchesResponse } from 'protos'
import { Action } from 'types'

import SelectMatch from '../SelectMatch'

type Props = {
  getMatchesFn: () => Promise<MatchesResponse>
  onMatchSelect: (matchId: string) => void
  showSponsored?: boolean
}

type State = {
  matches: Action<MatchesResponse | null>
}

class MatchesTab extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      matches: { isLoading: true }
    }

    props.getMatchesFn()
      .then((result: MatchesResponse) => {
        this.setState({ matches: { isLoading: false, result } })
      })
      .catch((err: Error) => {
        this.setState({ matches: { isLoading: false, errorCode: err.message } })
      })
  }

  renderContent = () => {
    const { matches } = this.state
    const { showSponsored, onMatchSelect } = this.props

    const sponsored = matches && matches.result && matches.result.sponsored
    const sponsoredMatch = sponsored && sponsored.match
    const sponsoredMatchId = sponsoredMatch && sponsoredMatch.matchId

    return (
      <CenteredContent>
        {showSponsored && sponsoredMatch && sponsoredMatchId && (
          <ButtonBase
            onClick={() => onMatchSelect(sponsoredMatchId)}
            style={{ width: '100%', display: 'block' }}
          >
            <FeaturedMatch match={sponsoredMatch} />
          </ButtonBase>
        )}
        <SelectMatch
          dateGroups={this.state.matches.result!.date || undefined}
          onMatchSelect={this.props.onMatchSelect}
        />
      </CenteredContent>
    )
  }

  render() {
    const { isLoading, errorCode } = this.state.matches

    return (
      <ActionContext
        isLoading={isLoading}
        errorCode={errorCode}
        component={this.renderContent}
        componentProps={{}}
      />
    )
  }
}

export default MatchesTab
